import {
  STORAGE_AUTH_USER_KEY,
} from '@/store/auth/auth.state';
import enums from '@/enums';

const user = JSON.parse(window.localStorage.getItem(STORAGE_AUTH_USER_KEY) || null);

let url = enums.AppLinks.API;

if (!url) {
  if (process.env.VUE_APP_ENV === enums.AppEnvironments.PRODUCTION) {
    url = 'https://grapeperks.io/api';
  } else if (process.env.VUE_APP_ENV === enums.AppEnvironments.STAGING) {
    url = 'https://staging.grapeperks.io/api';
  } else {
    url = 'http://localhost:3000';
  }
}

const configApi = {
  url,
  timeout: 0,
  token: null,
  refreshToken: null,
  userId: user ? user.id : null,
  limitApiCalls: process.env.VUE_APP_LIMIT_API_CALLS
    ? process.env.VUE_APP_LIMIT_API_CALLS.toLowerCase() === 'true'
    : true,
  fakeDb: process.env.VUE_APP_FAKE_DB
    ? process.env.VUE_APP_FAKE_DB.toLowerCase() === 'true'
    : false,
  baseRoutesUrls: {
    appServices: '/app-services',
    appServiceCountries: '/app-service-countries',
    appSettings: '/app-settings',
    attributes: 'attributes',
    auth: '/auth',
    callerIds: '/caller-ids',
    contacts: '/contacts',
    feedback: '/feedback',
    inboundSms: '/inbound-sms',
    notifications: '/notifications',
    segments: 'segments',
    smsCampaigns: '/sms-campaigns',
    smsTemplates: '/sms-templates',
    stripe: '/stripe',
    tags: 'tags',
    tenants: '/tenants',
    users: '/users',
    userSettings: '/settings',
    waitingList: '/waiting-list',
    reviews: '/reviews',
    imports: '/import-jobs',

    mmsTemplates: '/mms-templates',
    emailTemplates: '/email-templates',
    recordings: '/recordings',
    mailerIds: '/mailer-ids',
    mmsCampaigns: '/mms-campaigns',
    voiceCampaigns: '/voice-campaigns',
    emailCampaigns: '/email-campaigns',
    audiences: '/audiences',
  },
};

export default configApi;
